/**
 * Source: Figma "RM V2 Library (MUI v7.2.0)" — Theme page, `Variables Design Sheet` → `Card - responsive` → `breakpoint/*`.
 * https://www.figma.com/design/kMeScGRhmLq2l22M2ZkmiE/RM-V2-Library--MUI-v7.2.0-?node-id=11207-164308
 *
 * Verified with design (IL - 05/08/2026)
 */
export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;

export type BreakpointKey = keyof typeof breakpoints;
